import React from 'react';
import experiences from '../data/experience';

export default function Experience() {
  return (
    <section id="experience" className="py-6 px-6">
      <div className="slide-border-wrapper max-w-5xl mx-auto">
        <div className="slide-border-inner">

          <h3 className="text-3xl font-bold mb-4">Experience</h3>
          {experiences.map((exp, idx) => (
            <div key={idx} className="mb-6">
              <h4 className="text-xl font-semibold">{exp.role} - {exp.company}</h4>
              <p className="text-gray-400 text-sm">
                {exp.location} | {exp.duration}
              </p>
              <ul className="list-disc list-inside text-gray-300 mt-2">
                {exp.tasks.map((task, i) => <li key={i}>{task}</li>)}
              </ul>

              {/* Tech Stack Badges */}
              {exp.tech && (
  <div className="flex flex-wrap gap-2 mt-3">
    {exp.tech.map((item, i) => {
      const Icon = item.icon;
      return (
        <span
          key={i}
          className={`text-white text-sm px-2.5 py-1 rounded-full flex items-center gap-2 ${item.color}`}
        >
          {Icon && <Icon className="text-base" />}
          {item.name}
        </span>
      );
    })}
  </div>
)}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
